import Warning from '../Attributes/Warning/warning_electric_meter.json';
import ButtonDisable from '../Attributes/button_disable.json';
import MeterReadingDate from '../Attributes/meter_reading_date.json';
import Timer from '../Attributes/timer.json';
import UpdateFirmware from '../Attributes/update_firmware.json';
import RelayActionInit from '../Attributes/relay_action_init.json';
import Wifi from '../Attributes/Wifi/wifi_old.json';
import externalData from './externalData';

const config = {
    externalData,
    attributes: [ButtonDisable, RelayActionInit, Wifi, Timer, MeterReadingDate, Warning, UpdateFirmware],
    version: 'v0.0.1',
};

export default config;
